var React = require('react');

function Naviga (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n        .st0 {\n            fill: #FFFFFF;\n        }\n\n    "),React.createElement("g",{"id":"navigaIcon","key":1},[React.createElement("rect",{"id":"Rectangle_1","x":"1","y":"1","className":"st0","width":"10","height":"10","key":0}),React.createElement("rect",{"id":"Rectangle_1","x":"21","y":"1","className":"st0","width":"10","height":"10","key":1}),React.createElement("rect",{"id":"Rectangle_1","x":"1","y":"21","className":"st0","width":"10","height":"10","key":2}),React.createElement("rect",{"id":"Rectangle_1","x":"21","y":"21","className":"st0","width":"10","height":"10","key":3})])]);
}

Naviga.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Naviga;

Naviga.default = Naviga;
